'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  z-index: 10000000000000000;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: ', ';\n  visibility: ', ';\n  opacity: ', ';\n  ', ';\n'], ['\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  z-index: 10000000000000000;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: ', ';\n  visibility: ', ';\n  opacity: ', ';\n  ', ';\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var visible = _ref.visible;
  return visible ? 'auto' : 'none';
}, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 'visible' : 'hidden';
}, function (_ref3) {
  var visible = _ref3.visible;
  return visible ? 1 : 0;
}, (0, _polished.transitions)('visibility .3s ease-in-out, opacity .3s ease-in-out'));

Container.propTypes = {
  visible: _propTypes2.default.bool
};
exports.default = Container;